import { useNavigate } from 'react-router-dom';
import { useDefinedParams } from '../hooks/useDefinedParams';
import { usePortalQuery, EHttpMethod } from '../hooks/usePortalQuery';
import { Group, Contract, EPageViewType } from '../types';
import { useUserInfo } from '../hooks/useUserInfo';
import { EUserRole } from '@portal_components/types';
import { ContractView } from '../elements/contract/ContractView';
import { PageHeading } from '@portal_components/components/PageHeading';
import { useState } from 'react';
import axios from 'axios';
import { EnvironmentVariables } from '../EnvironmentVariables';

export const RenewContractPage = () => {
  const navigate = useNavigate();
  const { userInfo } = useUserInfo();
  const [groupId, contractId] = useDefinedParams(['groupId', 'contractId']);
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);

  const { data: group, isLoading: isGroupLoading } = usePortalQuery<Partial<Group>>(
    EHttpMethod.GET,
    `group/${groupId}`,
    'get-group',
    true
  );

  const { data: contract, isLoading: isContractLoading } = usePortalQuery<Partial<Contract>>(
    EHttpMethod.GET,
    `contract/${contractId}`,
    'get-contract',
    true
  );

  const handleSubmit = async (values: Partial<Contract>): Promise<{ success: boolean; message: string }> => {
    setFormSubmitted(true);
    const response = await axios
      .put(
        `${EnvironmentVariables.ApiUrl}/renew-contract`,
        {
          renewalEndDate: values.contractEndDate,
          contractId: contractId
        },
        {
          headers: {
            'Content-Type': 'application/json'
          },
          withCredentials: true
        }
      )
      .catch(error => error.response);
    if (!response) {
      setFormSubmitted(false);
      return { success: false, message: 'An error occurred while renewing contract.' };
    }
    if (response.status !== 200) {
      setFormSubmitted(false);
      return { success: false, message: response.data };
    }
    setTimeout(() => {
      navigate(`/`);
    }, 5000);
    return {
      success: true,
      message: 'Successfully renewed contract. You will be automatically redirected to the main page'
    };
  };

  if (!userInfo || userInfo.role === EUserRole.READONLY_USER)
    return <p className="text-center">You do not have permission to edit contracts.</p>;

  return (
    <div>
      <PageHeading title="Renew Contract" />
      {(isGroupLoading || isContractLoading) && (
        <div className="flex flex-row justify-center">Loading...</div>
      )}
      {group && contract && (
        <ContractView
          viewType={EPageViewType.RENEW}
          group={group}
          contract={contract}
          onSubmit={handleSubmit}
          formSubmitted={formSubmitted}
        />
      )}
    </div>
  );
};
